import { DateTime } from "luxon";
import { isUSFederalHoliday } from "./is-us-federal-holiday";

/**
 * Eastern Time is the time zone which we use for SWIFT
 */
export const ET_ZONE = "America/New_York";

/**
 * Calculates the next available processing date based on the current date and time in the America/New_York timezone.
 * Adjusts for weekends and federal US holidays.
 *
 * @returns The next available processing date as a DateTime object in UTC.
 */
export const getNextSwiftProcessingDateInUTC = () => {
  // Today's date in ET as ET is what we use for determining processing date.
  const todayInET = DateTime.now().setZone(ET_ZONE);
  let nextProcessingDay = todayInET;

  // Adjust for weekends and holidays
  while (nextProcessingDay.weekday >= 6 || isUSFederalHoliday(nextProcessingDay)) {
    nextProcessingDay = nextProcessingDay.plus({ days: 1 });
    nextProcessingDay = nextProcessingDay.startOf("day");
  }

  // Return the next processing date based on the current date and time in UTC
  nextProcessingDay = nextProcessingDay.toUTC();
  return nextProcessingDay;
};
